/**
 * Application configuration
 * Loads environment variables and provides typed configuration
 */

export interface AppConfig {
  apiBaseUrl: string;
  cognito: {
    userPoolId: string;
    clientId: string;
    region: string;
    domain: string;
    redirectUri: string;
  };
  capture: {
    intervalMs: number;
    maxRetries: number;
    jpegQuality: number;
    maxImageDimension: number;
  };
}

const config: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    redirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI || 'http://localhost:5173',
  },
  capture: {
    intervalMs: parseInt(import.meta.env.VITE_CAPTURE_INTERVAL_MS || '1000', 10),
    maxRetries: parseInt(import.meta.env.VITE_MAX_RETRIES || '3', 10),
    jpegQuality: parseInt(import.meta.env.VITE_JPEG_QUALITY || '75', 10),
    maxImageDimension: parseInt(import.meta.env.VITE_MAX_IMAGE_DIMENSION || '1024', 10),
  },
};

export default config;
